import { array, assign, integer, object, optional, partial } from 'superstruct';
import { AddArcRoleDto } from './add-arc-roles.dto';
export const EditArcRoleDto = partial(assign(AddArcRoleDto, object({
  groupIds: array(integer()),
  groupIdsToDelete: optional(array(integer()))
})));